module.exports = __webpack_public_path__ + "static/media/pores_cheek.4bbd1ab5.svg";